var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{attrs:{"placeholder":_vm.placeholder,"options":_vm.shengshiqu,"separator":" ","filterable":""},on:{"change":_vm.Change}})}
var staticRenderFns = []

export { render, staticRenderFns }